/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styles from "./styles.module.scss"
import { IMAGE_URL_v4 } from '../../../../envs/prod/constants'

export default function TeamRideSection({ windowSize }) {

    return (
        windowSize >=768 ? <div className={styles.teams_ride_wrapper}>
            <div className={styles.teams_ride_wrapper_inner}>
                <div className={styles.teams_ride_left}>
                    <div className={styles.teams_ride_header}>
                        <h2  className={styles.teams_ride_title}>Ride the ship with us</h2>
                    </div>
                    <div className={styles.teams_ride_content}>
                        <p className={styles.teams_ride_dec}>At Seekho, we’re always working to create a culture rooted in kindness, inclusivity, accountability, and growth. </p>
                    </div>
                    <div className={styles.teams_ride_cta}>
                    <a className={styles.teams_ride_button}  href="https://www.linkedin.com/company/seekhoapp/jobs/" target='_blank'>Apply now</a>
                    </div>
                </div>
                <div className={styles.teams_ride_image}>
                    <img alt="seekho" src={`${IMAGE_URL_v4}/teamspage/groupimg.webp`} />
                </div>
            </div> 
        </div> :
        <div className={styles.teams_ride_wrapper}>
            <div className={styles.teams_ride_header}>
                <h2  className={styles.teams_ride_title}>Ride the ship with us</h2>
            </div>
            <div className={styles.teams_ride_content}>
                <p className={styles.teams_ride_dec}>At Seekho, we’re always working to create a culture rooted in kindness, inclusivity, accountability, and growth. </p>
            </div>
            <div className={styles.teams_ride_image}>
                <img alt="seekho" src={`${IMAGE_URL_v4}/teamspage/groupimg.webp`} />
            </div>
            <div className={styles.teams_ride_cta}>
                <a className={styles.teams_ride_button}  href="https://www.linkedin.com/company/seekhoapp/jobs/" target='_blank'>Apply now</a>
            </div>
        </div>
    )
}
